/**
 * services/annuaire.js
 * The Crowd v2 — Recherche dans l'annuaire Entra (Microsoft Graph).
 *
 * Extrait de pages/CreationCompte.js, a l'identique : jeton Graph de
 * l'utilisateur connecte (scope delegue User.ReadBasic.All), silencieux
 * d'abord, fenetre de consentement en secours ; recherche par debut de
 * nom, d'adresse ou d'UPN, 8 resultats au plus.
 *
 * Isole ici pour que les composants v2 ne fassent aucun appel reseau :
 * la page passe la fonction de recherche au composant.
 */

export async function rechercherUtilisateursEntra(instance, account, query) {
  if (!query || query.length < 2) return [];
  const safe = query.replace(/'/g, "''");

  let token;
  try {
    const result = await instance.acquireTokenSilent({ scopes: ["User.ReadBasic.All"], account });
    token = result.accessToken;
  } catch {
    try {
      const result = await instance.acquireTokenPopup({ scopes: ["User.ReadBasic.All"], account });
      token = result.accessToken;
    } catch {
      return [];
    }
  }

  try {
    const filter = `startsWith(displayName,'${safe}') or startsWith(mail,'${safe}') or startsWith(userPrincipalName,'${safe}')`;
    const url = `https://graph.microsoft.com/v1.0/users?$filter=${filter}&$select=id,displayName,mail,userPrincipalName&$top=8&$count=true`;
    const resp = await fetch(url, {
      headers: { Authorization: `Bearer ${token}`, ConsistencyLevel: "eventual" },
    });
    if (!resp.ok) return [];
    const data = await resp.json();
    return (data.value || []).map((u) => ({ displayName: u.displayName, email: u.mail || u.userPrincipalName }));
  } catch {
    return [];
  }
}
